import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { sleepDiaryApi, NightInput } from "./api";
import { ApiAuth, ApiError } from "../../../lib/api";

const WEEK_KEY = "patient-sleep-diary-week";
const NIGHT_KEY = "patient-sleep-diary-night";

/** No range: the week that ends on last night, as the clinic's clock tells it. */
export function useSleepWeek(auth: ApiAuth, range?: { from: string; to: string }) {
  return useQuery({
    queryKey: [WEEK_KEY, range?.from ?? "last", range?.to ?? "last"],
    queryFn: () => sleepDiaryApi.week(auth, range),
  });
}

export function useSleepNight(auth: ApiAuth, day: string) {
  return useQuery({
    queryKey: [NIGHT_KEY, day],
    queryFn: () => sleepDiaryApi.get(auth, day),
  });
}

export function useSaveNight(auth: ApiAuth) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: NightInput) => sleepDiaryApi.save(auth, input),
    onSuccess: (res) => {
      // The save answer is the night: no refetch of it.
      qc.setQueryData([NIGHT_KEY, res.night.day], { success: true, night: res.night, prefill: null });
      qc.invalidateQueries({ queryKey: [WEEK_KEY] });
      // A later night may hold a prefill built from the night just saved.
      qc.invalidateQueries({ queryKey: [NIGHT_KEY], predicate: (q) => q.queryKey[1] !== res.night.day });
    },
    onError: (err) => {
      // Another save landed: the week's saved days may be stale too.
      if (err instanceof ApiError && err.code === "SLEEP_NIGHT_CONFLICT") qc.invalidateQueries({ queryKey: [WEEK_KEY] });
    },
  });
}
